export var ACTION;
(function (ACTION) {
    ACTION["TEST_ACTION"] = "TEST_ACTION";
    ACTION["ON_LOAD"] = "ON_LOAD";
    ACTION["CLOSE_POP_UP"] = "CLOSE_POP_UP";
    ACTION["GO_TO_REGISTER"] = "GO_TO_REGISTER";
    ACTION["ON_LOAD_PLJ_ACTION"] = "ON_LOAD_PLJ_ACTION";
    ACTION["ON_COPY_LINK"] = "ON_COPY_LINK";
    ACTION["ON_SHARE_LINK"] = "ON_SHARE_LINK";
})(ACTION || (ACTION = {}));
// export type TestActionPayload = {}
